import defaultThreshold from 'constants/defaultThreshold';

import type {
  OutOfRangeParam,
  ParamDirection,
  ParamLevel,
  RecheckResult,
} from './types';

export const classifyRecheckLevel = (
  params: OutOfRangeParam[],
): RecheckResult => {
  if (params.some((p) => p.level === 'critical')) return 'still-critical';
  if (params.some((p) => p.level === 'risk')) return 'at-risk';
  return 'normal';
};

const LOW_ONLY = new Set(['oxygen', 'pef', 'fev1']);

export const deriveDirection = (
  param: string,
  value: number,
  minRisk: number | undefined,
  maxRisk: number | undefined,
): ParamDirection => {
  if (LOW_ONLY.has(param)) return 'low';
  if (param === 'temperature') {
    // Fever if above the critical-high bound; otherwise treat as hypothermia (low).
    return typeof maxRisk === 'number' && value > maxRisk ? 'high' : 'low';
  }
  if (typeof maxRisk === 'number' && value > maxRisk) return 'high';
  if (typeof minRisk === 'number' && value < minRisk) return 'low';
  if (typeof maxRisk === 'number' && typeof minRisk === 'number') {
    const mid = (maxRisk + minRisk) / 2;
    return value >= mid ? 'high' : 'low';
  }
  return 'high';
};

export type { ParamLevel };
export { defaultThreshold };
